if (!customElements.get('tracking-viewed-products')) {
  customElements.define(
    'tracking-viewed-products',
    class TrackingViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.record({ name: 'shopify_recently_viewed_products', expire: '30', max: 10 });
      }
    
      readCookie (name) {
        let list = [],
        data = getCookie(name);
        if (data !== null && data !== undefined && data !== '') list = data.split(' ');
        return list;
      }
    
      setCookie(params, list) {
        if (this.dataset.productId !== '') {
          let productId = this.dataset.productId,
            position = list.indexOf(productId);
          if (position === -1) {
            list.unshift(productId);
            list = list.splice(0, params.max);
          } else {
            list.splice(position, 1);
            list.unshift(productId);
          }
          this.writeCookie(params.name, params.expire, list);
        }
      }
    
      writeCookie(name, day, list) {
        setCookie(name, list.join(' '), { expires: day, path: '/', domain: window.location.hostname });
      }
    
      destroyCookie (name, day) {
        setCookie(name, null, { expires: day, path: '/', domain: window.location.hostname });
      }
    
      record(params) {    
        this.setCookie(params, this.readCookie(params.name));
      }
    }
  );
}